import React from 'react'
import { Alert, Button, Form } from 'react-bootstrap'
import useManualPayment from './useManualPayment'

const ManualPaymentForm = props => {
    const form = useManualPayment(props)
    return (
        <Form onSubmit={event => { event.preventDefault(); form.save() }} className='mt-3'>
            <h5>Record manual payment</h5>
            <p>Record money already received outside PayPal. Saving adds it to this player's payment log.</p>
            {form.error ? <Alert variant='danger'>{form.error}</Alert> : null}
            <fieldset disabled={form.isSaving}>
                <Form.Group className='mb-3' controlId='manual-payment-amount'>
                    <Form.Label>Amount (USD)</Form.Label>
                    <Form.Control type='number' min='0.01' max={form.maxAmount} step='0.01'
                        required value={form.amount} onChange={event => form.setAmount(event.target.value)} />
                </Form.Group>
                <Form.Group className='mb-3' controlId='manual-payment-method'>
                    <Form.Label>Payment method</Form.Label>
                    <Form.Select value={form.paymentMethod} onChange={event => form.setPaymentMethod(event.target.value)}>
                        {['Cash', 'Venmo', 'Zelle', 'Other'].map(method => <option key={method}>{method}</option>)}
                    </Form.Select>
                </Form.Group>
                <Form.Group className='mb-3' controlId='manual-payment-reference'>
                    <Form.Label>Reference (optional)</Form.Label>
                    <Form.Control maxLength={500} value={form.paymentReference} onChange={event => form.setPaymentReference(event.target.value)} />
                </Form.Group>
                <Form.Group className='mb-3' controlId='manual-payment-note'>
                    <Form.Label>Note {form.paymentMethod === 'Other' ? '(describe payment method)' : '(optional)'}</Form.Label>
                    <Form.Control as='textarea' rows={2} maxLength={500} required={form.paymentMethod === 'Other'}
                        value={form.paymentNote} onChange={event => form.setPaymentNote(event.target.value)} />
                </Form.Group>
                <Button type='submit' disabled={!form.isValid || form.isSaving}>
                    {form.isSaving ? 'Recording payment…' : 'Record payment'}
                </Button>
            </fieldset>
        </Form>
    )
}

export default ManualPaymentForm
